import React from "react";

const eligibilityItems = [
  "Belong to a notified minority community.",
  "Meet the family income criteria prescribed by NMDFC.",
  "Be a member of a Self-Help Group, Joint Liability Group, or other eligible group, wherever applicable.",
  "Be willing to undertake or expand an income-generating activity.",
  "Comply with the eligibility conditions prescribed by the implementing agency.",
];

const documentItems = [
  "Loan application form",
  "Aadhaar Card",
  "Identity and address proof",
  "Income certificate",
  "Passport-size photographs",
  "SHG/JLG membership details (where applicable)",
  "Bank account details",
  "Activity proposal or business plan",
  "Any other documents required by the implementing agency",
];

const purposeItems = [
  "Starting new micro-enterprises",
  "Expanding existing small businesses",
  "Purchase of tools, equipment, machinery, or livestock",
  "Purchase of raw materials and inventory",
  "Meeting day-to-day working capital requirements",
  "Creating self-employment opportunities",
  "Improving household income and promoting sustainable livelihoods",
];

const MicroFinanceSchemeContent = () => {
  return (
    <div className="space-y-7 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">Introduction</h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The NMDFC Micro Finance Scheme is designed to provide small-value
          loans to economically weaker individuals belonging to notified
          minority communities for undertaking income-generating activities.
          Implemented primarily through Self-Help Groups (SHGs), Joint Liability
          Groups (JLGs), and partner organizations, the scheme promotes
          financial inclusion, women empowerment, and sustainable
          self-employment at the grassroots level.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          Under the Micro Financing Scheme, micro-credit is extended to the
          members of the Self Help Groups (SHGs), especially minority women
          scattered in remote villages and urban slums, who are not able to take
          advantage of formal banking credit. The scheme requires beneficiaries
          to be organized into Self Help Groups (SHGs) and develop the habit of
          thrift and credit, however small.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          Preference is given to SHGs formed under the National Rural Livelihood
          Mission (NRLM) and the National Urban Livelihood Mission (NULM) of the
          respective States under the Ministry of Rural Development Programme,
          Government of India. The scheme envisages providing micro-credit to
          the poorest among the poor mainly through State Channelizing Agencies
          (SCAs) and also through NGOs with a proven track record and their
          network of Self Help Groups.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          It is a loan scheme with minimal documentation, ensuring quick
          delivery of loans at the beneficiaries' doorstep.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Eligibility</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants must:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {eligibilityItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">
          Documents Required
        </h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants are generally required to submit:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {documentItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Purpose of Loan</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          The loan can be utilized for:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {purposeItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default MicroFinanceSchemeContent;
